import _ from 'lodash';

import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';

export class IASWDClientPlugin extends SmartenitPlugin {
  public onInit() { }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    return this.state;
  }

  public getConditionOptions(): any {
    return [
      {
        displayName: _.capitalize(
          _.get(
            this.translationService.getResource(),
            'AR.CONDITIONS_NL.PRESSED',
            ''
          )
        ),
        method: {
          attribute: 'Mode',
          name: 'Startwarning'
        },
        name: 'Pressed',
        value: {
          '#bitmask': '0x0F'
        }
      }
    ];
  }

  public getConditionAttribute() {
    return null;
  }

  public getEffectOptions(): any {
    return null;
  }

  public getEffectAttribute(): string | null {
    return null;
  }

  public getEffectMethod(context?: any): string | null {
    return null;
  }
}
